module.exports = __webpack_public_path__ + "img/ssao_only.5de94949.webp";